module.exports = __webpack_public_path__ + "img/logo_biblioteca.577d29aa.png";